<template>
  <div id="organisation-overview">
    <div class="content-wrapper">
      
      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{$t('organisation.overview.title')}}</h5>

            <div class="header-elements">
              <el-button-group>

                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini"></el-button>
                </el-tooltip>

              </el-button-group>
            </div>
          </div>



        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "OrganisationSettings",

  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {

  },
  watch: {

  },
  methods: {

  },
};
</script>


<style lang="less">
#organisation-overview {

}
</style>




// WEBPACK FOOTER //
// src/pages/OrganisationSettings.vue